export default "__VITE_ASSET__DKimUKF3__"